import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ContentsSection, EditerBox } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { CustomPopup, LoadingBox } from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import { comFormat, datePramaSet, getDateGap, setDateTime } from "js/function";
import { CarDetailItem } from "component/product/car";
import { FixedPage, FixedSection } from "component/basic";
import { TermsPopupSubTitle } from "component/app/subItem";
import { NotItems } from "component/basic/notItems";
import { Tap } from "component/basic/tap";
import { AddProductItem, AddProductListBox, AddProductListItem, CarDetailControllBox, CarDetailSection, CarDetailTextArea, CarDetailTextBox, CarSetInfoCaption, CarSetInfoItem, CarSetInfoSection, FixedContents, PopupCaptionTextBox, PopupCaptionTextItem, ReservationEditSetArea, ReservationEditSetSection, ResetBtn } from "component/product/page";

const ReservationEdit = (props) => {
    const navigate = useNavigate();
    const param = useParams();
    const id = param.id;

    const location = useLocation();
    const locationData = location?.state ? location?.state : null;
    const paymentDataLoca = locationData?.paymentData;
    const memberCode = locationData?.memberCode;
    
    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const [paymentData,setPaymentData] = useState({
        reservation_id:id,
        
        reservationData:null,
        insurance_id:null,
        insurance_name:null,
        cCode:null,
        mCode:null,

        start_date:null,
        end_date:null,
    
        add_product:[],
        add_productChk:false
    });

    const pageDataApi = useGet({
        url:`/reservation/detail?reservation_id=${id}${localStorage.getItem("token") ? "" : `&code=${memberCode?.code}&phone=${memberCode?.phone}`}`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data?.reservation;

    const carDetailDataApi = useGet({
        url:paymentData?.reservationData || (paymentData?.start_date && paymentData?.end_date) ? 
        `/reservation/car/detail?company_mapped_code=${paymentData?.reservationData ? paymentData?.cCode : pageData?.company_mapped_code}
        &model_mapped_code=${paymentData?.reservationData ? paymentData?.mCode : pageData?.model_mapped_code}
        &review_order=desc
        &start_date=${paymentData?.start_date ? datePramaSet(paymentData?.start_date) : pageData?.start_date ? datePramaSet(pageData?.start_date) : ""}
        &end_date=${paymentData?.end_date ? datePramaSet(paymentData?.end_date) : pageData?.end_date ? datePramaSet(pageData?.end_date) : ""}
        &insurance_id=${(paymentData?.insurance_id ? paymentData?.insurance_id : pageData?.insurance_id)||""}` : null,
        loginType:null
    });
    const carDetailData = carDetailDataApi?.data?.car;
    const rentDay = pageData ? getDateGap(pageData?.start_date,pageData?.end_date,"day") : 0;
    const rentDayPayment = paymentData?.start_date && paymentData?.end_date ? getDateGap(paymentData?.start_date,paymentData?.end_date,"day") : null;

    const [total,setTotal] =  useState(0);

    const categoryApi = useGet({
        url:`/add/product/category`,
        loginType:"login"
    });
    const categoryData = categoryApi?.data?.add_product_categories;
    
    const [categoryId,setCategoryId] =  useState(null);
    
    const addProductApi = useGet({
        url:categoryId ? `/add/product?category_id=${categoryId}` : null,
        loginType:"login"
    });
    const addProductData = addProductApi?.data?.add_products;
    
    const [addProductItem,setAddProductItem] =  useState([]);
    const [addProductSelItem,setAddProductSelItem] =  useState([]);
    
    const [addProductPopup,setAddProductPopup] =  useState(null);
    
    const [addTotalPrice,setAddTotalPrice] =  useState(0);
    const [addTotalQty,setAddTotalQty] =  useState(0);
    const [addTotalPriceSel,setAddTotalPriceSel] =  useState(0);

    const ruleApi = useGet({
        url:`/reservation/rule`,
        loginType:"login"
    });
    const ruleData = ruleApi?.data;

    const [reservationPopup,setReservationPopup] =  useState(null);

    const cancelPriceApi = useGet({
        url:id && (localStorage.getItem("token") ? true : memberCode ? true : false) ? `/reservation/cancel/check?reservation_id=${id}${localStorage.getItem("token") ? "" : `&code=${memberCode?.code}&phone=${memberCode?.phone}`}` : null,
        loginType:"login"
    });
    const cancel_price = cancelPriceApi?.data?.cancel_price;
    
    function paymentDataCh(key,val){
        let oldData = {...paymentData};
        oldData[key] = val;
        setPaymentData(oldData);
    }

    function addProductQtyFunc(item,qty){
        let oldSelItem = [...addProductSelItem];
        let oldItem = [...addProductItem];

        if(qty == 0){
            oldSelItem = oldSelItem?.filter((el)=>el.id !== item.id);
        }else{
            if(oldSelItem?.filter((el)=>el.id === item.id)?.length > 0){
                oldSelItem = oldSelItem?.map((subItem) => subItem.id === item.id ? 
                    {
                        ...subItem,
                        qty: qty
                    } 
                : subItem)
            }else{
                oldSelItem.push({
                    ...item,
                    qty: qty
                })
            }
        }

        setAddProductSelItem(oldSelItem);

        if(oldItem?.filter((el)=>el.id === item.id)?.length > 0){
            oldItem = oldItem?.map((subItem) => subItem.id === item.id ? 
                {
                    ...subItem,
                    qty: qty
                } 
            : subItem)
        }else{
            oldItem.push({
                ...item,
                qty: qty
            })
        }

        setAddProductItem(oldItem);
    }

    function addProductFunc(){
        let selItem = [...addProductSelItem];
        let oldData = {...paymentData};
        oldData.add_product = selItem;
        oldData.add_productChk = true;

        setPaymentData(oldData);
    }

    function totalPrice(){
        let total = 0;
        let totalAddProduct = 0;
    
        if(paymentData?.add_productChk && paymentData?.add_product?.length == 0){
            setAddTotalPriceSel(totalAddProduct);

            if((paymentData?.reservationData || (paymentData?.start_date && paymentData?.end_date)) && carDetailData){
                total = total + Number(carDetailData?.discount_price ? carDetailData?.discount_price : carDetailData?.original_price);
                setTotal(total);
            }else{
                setTotal(total);
            }
        }else if(paymentData?.add_product?.length > 0){
            paymentData?.add_product?.forEach(function(item,i){
                total = total + (item.price * item.qty * (rentDayPayment ? rentDayPayment : rentDay));
                totalAddProduct = totalAddProduct + (item.price * item.qty * (rentDayPayment ? rentDayPayment : rentDay));
        
                if(paymentData?.add_product?.length - 1 === i){
                    setAddTotalPriceSel(totalAddProduct);

                    if((paymentData?.reservationData || (paymentData?.start_date && paymentData?.end_date)) && carDetailData){
                        total = total + Number(carDetailData?.discount_price ? carDetailData?.discount_price : carDetailData?.original_price);
                        setTotal(total);
                    }else{
                        setTotal(total);
                    }
                }
            });
        }else if((paymentData?.reservationData || (paymentData?.start_date && paymentData?.end_date)) && carDetailData){
            if(pageData?.add_products?.length > 0){
                pageData?.add_products?.forEach(function(item,i){
                    total = total + (Math.floor((item.price / item.amount / rentDay)||0) * item.amount * (rentDayPayment ? rentDayPayment : rentDay));
                    if(pageData?.add_products?.length - 1 === i){    
                        total = total + Number(carDetailData?.discount_price ? carDetailData?.discount_price : carDetailData?.original_price);
                        setTotal(total);
                    }
                });
            }else{
                total = total + Number(carDetailData?.discount_price ? carDetailData?.discount_price : carDetailData?.original_price);
                setTotal(total);
            }
        }else{
            setTotal(total);
        }
    }

    useEffect(() => {
        if(pageData){
            setLoadingBoxOpen(false);
        }
    }, [pageDataApi]);

    useEffect(() => {
        setTimeout(() => {
            setLoadingBoxOpen(false);
        }, 2000);
    }, []);

    useEffect(() => {
        if(paymentDataLoca){
            let oldData = {...paymentDataLoca};
            setPaymentData(oldData);
        }
    }, []);

    useEffect(() => {
        if(paymentDataLoca){
            let oldData = {...paymentDataLoca};
            setPaymentData(oldData);
        }
    }, [paymentDataLoca]);

    useEffect(() => {
        if(categoryData && categoryData?.length > 0){
            setCategoryId(categoryData[0]?.id);
        }
    }, [categoryApi]);
    
    useEffect(() => {
        if(addProductData){
            let newData = [...addProductData];
            let selData = paymentData.add_product ? [...paymentData.add_product] : [];
    
            newData = newData?.map((subItem) => selData?.filter((el)=>el.id === subItem.id)?.length > 0 ? 
                {
                    ...subItem,
                    qty: selData?.filter((el)=>el.id === subItem.id)[0].qty
                } 
            : 
                {
                    ...subItem,
                    qty: 0
                }
            )
    
            setAddProductItem(newData);
        }
    }, [addProductApi]);

    useEffect(() => {
        let total = 0;
        let qty = 0;
    
        addProductSelItem?.forEach(function(item,i){
            total = total + (item.price * item.qty * (rentDayPayment ? rentDayPayment : rentDay));
            qty = qty + item.qty;
    
            if(addProductSelItem?.length - 1 === i){
                setAddTotalPrice(total);
                setAddTotalQty(qty);
            }
        });

        if(addProductSelItem?.length <= 0){
            setAddTotalPrice(0);
            setAddTotalQty(0);
        }
    }, [addProductSelItem]);

    useEffect(() => {
        if((carDetailDataApi && paymentData?.reservationData && (paymentData?.start_date||pageData?.start_date) && (paymentData?.end_date||pageData?.end_date)) && !carDetailData){
            let oldData = {...paymentData};
            oldData.reservationData = null;
            oldData.insurance_id = null;
            oldData.insurance_name = null;
            oldData.cCode = null;
            oldData.mCode = null;

            setPaymentData(oldData);

            window.errPopupOpen({
                alert:"예약 변경 불가",
                data:`현재 일정으로 선택된 차량 예약이 불가능합니다.<br/>일정 변경 후 차량을 다시 선택해주세요.`,
                closeType:true,
                func:()=>{}
            });
        }
    }, [carDetailDataApi]);

    useEffect(() => {
        totalPrice();
    }, [paymentData,carDetailDataApi]);

    useEffect(() => {
        totalPrice();
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={false}
                pcFooter={true}
                addClass={"gBg mBtnPoint"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"예약내역"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={1}
                    closeFunc={()=>{}}
                />

                <FixedPage addClass="detailFixedPage">
                    <FixedContents addClass="">
                        <CarDetailItem
                            itemType="edit"
                            sectionTitle={paymentData?.reservationData && carDetailData ? "차량 정보" : null}
                            sectionTitleSubItem={
                                paymentData?.reservationData && carDetailData ? 
                                <>
                                 <ResetBtn func={()=>{
                                    let oldData = {...paymentData};
                                    oldData.reservationData = null;
                                    oldData.insurance_id = null;
                                    oldData.insurance_name = null;
                                    oldData.cCode = null;
                                    oldData.mCode = null;

                                    setPaymentData(oldData);
                                }}/>
                                </>
                                : null}
                            sectionCaptions={null}
                            status={null}
                            model_id={paymentData?.reservationData && carDetailData ? carDetailData?.model_id : pageData?.model_id}
                            car_image={paymentData?.reservationData && carDetailData ? carDetailData?.image_url : pageData?.image_url}
                            car_image_alt={paymentData?.reservationData && carDetailData ? carDetailData?.image_alt : pageData?.image_alt}
                            maker={paymentData?.reservationData && carDetailData ? carDetailData?.maker : pageData?.maker}
                            modelName={paymentData?.reservationData && carDetailData ? carDetailData?.name : pageData?.name}
                            passengerNum={paymentData?.reservationData && carDetailData ? carDetailData?.passenger_number : pageData?.passenger_number}
                            fuelType={paymentData?.reservationData && carDetailData ? carDetailData?.fuel : pageData?.fuel}
                            min_year={paymentData?.reservationData && carDetailData ? carDetailData?.min_year : pageData?.min_year}
                            max_year={paymentData?.reservationData && carDetailData ? carDetailData?.max_year : pageData?.max_year}
                            car_option={carDetailData ? carDetailData?.options : pageData?.options}
                            carOptionDisable={paymentData?.reservationData && carDetailData ? carDetailData?.non_options : pageData?.non_options}
                            insurance_name={paymentData?.reservationData && carDetailData ? paymentData?.insurance_name : pageData?.insurance_name}
                            func={()=>{
                                navigate(`/reservation/edit/list/${id}`,{state:{paymentData:paymentData,pageData:pageData,memberCode:memberCode}})
                            }}
                        />
                        <CarDetailSection 
                            addClass="titleSubItem_row"
                            title="일정 정보"
                            titleSubItem={
                                paymentData?.start_date && paymentData?.end_date ? 
                                <>
                                 <ResetBtn func={()=>{
                                    let oldData = {...paymentData};
                                    oldData.start_date = null;
                                    oldData.end_date = null;
                                    setPaymentData(oldData);
                                }}/>
                                </>
                                : null}
                        >
                            <CarDetailTextArea title={null} addClass="">
                                {paymentData?.start_date && paymentData?.end_date ? 
                                <ReservationEditSetSection>
                                    <ReservationEditSetArea
                                        title={"변경 전"}
                                        addClass="oldData"
                                        titleAddClass=""
                                    >
                                        <CarDetailTextBox
                                            addClass=""
                                            name={`대여일시`}
                                            text={pageData?.start_date ? setDateTime(pageData?.start_date,"dayyyMinmmddhh",null) : "-"}
                                        />
                                        <CarDetailTextBox
                                            addClass=""
                                            name={`반납일시`}
                                            text={pageData?.end_date ? setDateTime(pageData?.end_date,"dayyyMinmmddhh",null) : "-"}
                                        />
                                    </ReservationEditSetArea>
                                    <ReservationEditSetArea
                                        title={"변경 후"}
                                        titleAddClass="wbTextColor"
                                    >
                                        <CarDetailTextBox
                                            addClass=""
                                            name={`대여일시`}
                                            text={paymentData?.start_date ? setDateTime(paymentData?.start_date,"dayyyMinmmddhh",null) : "-"}
                                        />
                                        <CarDetailTextBox
                                            addClass=""
                                            name={`반납일시`}
                                            text={paymentData?.end_date ? setDateTime(paymentData?.end_date,"dayyyMinmmddhh",null) : "-"}
                                        />
                                    </ReservationEditSetArea>
                                </ReservationEditSetSection>
                                :
                                <>
                                    <CarDetailTextBox
                                        addClass=""
                                        name={`대여일시`}
                                        text={pageData?.start_date ? setDateTime(pageData?.start_date,"dayyyMinmmddhh",null) : "-"}
                                    />
                                    <CarDetailTextBox
                                        addClass=""
                                        name={`반납일시`}
                                        text={pageData?.end_date ? setDateTime(pageData?.end_date,"dayyyMinmmddhh",null) : "-"}
                                    />
                                </>
                                }
                            </CarDetailTextArea>
                            <BtnItem
                                addClass="subColor carEditBtn"
                                contents={"일정 변경"}
                                func={() => {
                                    navigate(`/reservation/edit/date/${id}`,{state:{paymentData:paymentData,pageData:pageData,memberCode:memberCode}})
                                }}
                            />
                        </CarDetailSection>
                        <CarDetailSection 
                            addClass="titleSubItem_row"
                            title="부가서비스"
                            titleSubItem={paymentData?.add_product?.length > 0 || paymentData?.add_productChk ? 
                            <>
                                <ResetBtn func={()=>{
                                    let selItem = [];
                                    let oldData = {...paymentData};
                                    oldData.add_product = selItem;
                                    oldData.add_productChk = false;

                                    setPaymentData(oldData);
                                }}/>
                            </>
                            : null}
                        >
                            <CarDetailTextArea title={null} addClass="">
                                {paymentData?.add_product?.length > 0 || paymentData?.add_productChk ? 
                                <ReservationEditSetSection>
                                    <ReservationEditSetArea
                                        title={"변경 전"}
                                        addClass="oldData"
                                        titleAddClass=""
                                    >
                                        {pageData?.add_products && pageData?.add_products?.length > 0 ? 
                                            <>
                                                {pageData?.add_products && pageData?.add_products?.map((item,i)=>(
                                                    <CarDetailTextBox
                                                        key={i}
                                                        addClass=""
                                                        name={`${item.name} * ${item.amount}`}
                                                        text={`${comFormat(item.price)} 원`}
                                                    />
                                                ))}
                                            </>
                                        :
                                            <NotItems addClass="min" text={`선택된 부가서비스가 없습니다.`}/>
                                        }
                                    </ReservationEditSetArea>
                                    <ReservationEditSetArea
                                        title={"변경 후"}
                                        titleAddClass="wbTextColor"
                                    >
                                        {paymentData?.add_product && paymentData?.add_product?.length > 0 ? 
                                            <>
                                                {paymentData?.add_product && paymentData?.add_product?.map((item,i)=>(
                                                    <CarDetailTextBox
                                                        key={i}
                                                        addClass=""
                                                        name={`${item.name} * ${item.qty}`}
                                                        text={`${comFormat(item.price * item.qty * (rentDayPayment ? rentDayPayment : rentDay))} 원`}
                                                    />
                                                ))}
                                            </>
                                        :
                                            <NotItems addClass="min" text={`선택된 부가서비스가 없습니다.`}/>
                                        }
                                    </ReservationEditSetArea>
                                </ReservationEditSetSection>
                                : pageData?.add_products && pageData?.add_products?.length > 0 ? 
                                <>
                                    {pageData?.add_products?.map((item,i)=>(
                                        <AddProductItem
                                            key={i}
                                            addClass=""
                                            id={item.id}
                                            img={item.image_url}
                                            imgAlt={item.image_alt}
                                            category={item.category||"-"}
                                            name={item.name}
                                            price={Math.floor((item.price / item.amount / rentDay)||0)}
                                            totalPrice={item.price}
                                            amount={item.amount}
                                            day={rentDay}
                                        />
                                    ))}
                                </>
                                :
                                <NotItems addClass="bigText sectionNotItem" text="선택된 부가서비스가 없습니다."/>}
                            </CarDetailTextArea>
                            <BtnItem
                                addClass="subColor carEditBtn"
                                contents={"부가서비스 변경"}
                                func={() => {
                                    let oldData = [...paymentData?.add_product];
                                    setAddProductSelItem(oldData);

                                    setAddProductPopup({
                                        addClass:"tapInPopup addProductSelPopup",
                                        title:"부가서비스 변경",
                                        subTitle:null,
                                        closeType:true,
                                        closeFunc:(e) => {
                                            setAddProductPopup(null)
                                        }
                                    });
                                }}
                            />
                        </CarDetailSection>
                        <CarDetailSection title="예약 변경 시 재결제 안내">
                            <EditerBox addClass="" data={ruleData?.exchange_information||"-"}/>
                        </CarDetailSection>
                    </FixedContents>
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass=""
                        addClass="nonFixed mNonMb"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <CarDetailControllBox
                            addClass={"nonFixed"}
                            title={null}
                            subTitle={"변경 예약 정보"}
                        >
                            <CarSetInfoSection>
                                <CarSetInfoItem
                                    addClass="mSize"
                                    name="차량 대여요금 (자차보험 포함)"
                                    text={`${comFormat((paymentData?.reservationData || (paymentData?.start_date && paymentData?.end_date)) && carDetailData ? carDetailData?.discount_price ? carDetailData?.discount_price : carDetailData?.original_price : pageData?.original_price||"0")} 원`}
                                /> 
                                <CarSetInfoItem
                                    addClass=""
                                    name="예약 시간"
                                    text={
                                        paymentData?.start_date && paymentData?.end_date ? 
                                        `${paymentData?.start_date && paymentData?.end_date ? getDateGap(paymentData?.start_date,paymentData?.end_date,"time",null) : "-"}시간`
                                        : `${pageData?.start_date && pageData?.end_date ? getDateGap(pageData?.start_date,pageData?.end_date,"time",null) : "-"}시간`
                                    }
                                />
                                <CarSetInfoItem
                                    addClass=""
                                    name="보험 정보"
                                    text={((paymentData?.reservationData || (paymentData?.start_date && paymentData?.end_date)) && carDetailData ? paymentData?.insurance_name : pageData?.insurance_name)||"-"}
                                />
                                <CarSetInfoItem
                                    addClass="mSize"
                                    name="대여/반납일시"
                                    text={null}
                                />
                                <CarSetInfoItem
                                    addClass=""
                                    name={
                                        paymentData?.start_date && paymentData?.end_date ? 
                                        paymentData?.start_date ? setDateTime(paymentData?.start_date,"dayyyMinmmddhh",null) : "-"
                                        : pageData?.start_date ? setDateTime(pageData?.start_date,"dayyyMinmmddhh",null) : "-"
                                    }
                                    text={`부터`}
                                />
                                <CarSetInfoItem
                                    addClass=""
                                    name={
                                        paymentData?.start_date && paymentData?.end_date ? 
                                        paymentData?.end_date ? setDateTime(paymentData?.end_date,"dayyyMinmmddhh",null) : "-"
                                        : pageData?.end_date ? setDateTime(pageData?.end_date,"dayyyMinmmddhh",null) : "-"
                                    }
                                    text={`까지`}
                                />
                            </CarSetInfoSection>
                            <CarSetInfoSection>
                                <CarSetInfoItem
                                    addClass="mSize"
                                    name="할인 적용"
                                    text={`${(Number(pageData?.coupon_price||"0") + Number(pageData?.use_point||"0")) > 0 ? "- " : ""}${comFormat(String(Number(pageData?.coupon_price||"0") + Number(pageData?.use_point||"0")))} 원`}
                                />
                                {pageData?.coupon_price ? 
                                    <CarSetInfoItem
                                        addClass=""
                                        name={pageData?.coupon_name}
                                        text={`${pageData?.coupon_price > 0 ? "- " : ""}${comFormat(pageData?.coupon_price||"0")} 원`}
                                    />
                                :""}
                                <CarSetInfoItem
                                    addClass=""
                                    name="포인트 사용"
                                    text={`${pageData?.use_point > 0 ? "- " : ""}${comFormat(pageData?.use_point||"0")} 원`}
                                />
                            </CarSetInfoSection>
                            <CarSetInfoSection>
                                <CarSetInfoItem
                                    addClass="mSize"
                                    name="부가서비스"
                                    text={`${comFormat((paymentData?.add_product?.length > 0 || paymentData?.add_productChk ? addTotalPriceSel : (Number(pageData?.add_product_price) / rentDay * (rentDayPayment ? rentDayPayment : rentDay)))||"0")} 원`}
                                /> 
                                {paymentData?.add_product?.length > 0 || paymentData?.add_productChk ? 
                                    <>
                                        {paymentData?.add_product && paymentData?.add_product?.map((item,i)=>(
                                            <CarSetInfoItem
                                                key={i}
                                                addClass=""
                                                name={`${item.name} * ${item.qty}`}
                                                text={`${comFormat((item.price * item.qty * (rentDayPayment ? rentDayPayment : rentDay))||"0")} 원`}
                                            />
                                        ))}
                                    </>
                                : pageData?.add_products ? 
                                    <>
                                        {pageData?.add_products?.map((item,i)=>(
                                            <CarSetInfoItem
                                                key={i}
                                                addClass=""
                                                name={`${item.name} * ${item.amount}`}
                                                text={`${comFormat((Math.floor((item.price / item.amount / rentDay)||0) * item.amount * (rentDayPayment ? rentDayPayment : rentDay))||"0")} 원`}
                                            />
                                        ))}
                                    </>
                                :""}
                            </CarSetInfoSection>
                            <CarSetInfoSection>
                                <CarSetInfoItem
                                    addClass="bSize"
                                    name="총 결제 금액"
                                    text={`<span class='wbTextColor'>${comFormat(total)} 원</span>`}
                                />
                                <CarSetInfoItem
                                    addClass="mSizeg"
                                    name="이전 결제 건 환불 금액"
                                    text={`- ${comFormat(String(Number(pageData?.payment_price||0) - Number(cancel_price||0)))} 원`}
                                />
                            </CarSetInfoSection>
                            <CarSetInfoCaption
                                captions={[
                                    "예약 변경 시, 이전 결제 건에 환불 수수료가 발생될 수 있습니다."
                                ]}
                                btn="환불 수수료 정책 안내"
                                func={()=>{
                                    setReservationPopup({
                                        addClass:"",
                                        title:"예약 취소/변경 규정 안내",
                                        subTitle:null,
                                        closeType:true,
                                        closeFunc:(e) => {setReservationPopup(null)},
                                        closePcOn:true
                                    });
                                }}
                            />
                            <BtnBox
                                boxType=""
                                addClass={"row2_re mCol2 mFixed"}
                            >
                                <BtnItem
                                    addClass="dbColor"
                                    contents="뒤로"
                                    func={() => {
                                        navigate(-1)
                                    }}
                                />
                                <BtnItem
                                    addClass=""
                                    contents={`${comFormat(total)} 원 결제하기<img src="/assets/images/basic/filter_btn_move.svg"/>`}
                                    func={() => {
                                        if(paymentData?.reservationData || (paymentData?.start_date && paymentData?.end_date) || (paymentData?.add_product?.length > 0 || paymentData?.add_productChk)){
                                            navigate("/edit/payment",{state: {paymentData:paymentData,reservationData:pageData,carData:carDetailData,addTotalPriceSel:addTotalPriceSel,memberCode:memberCode}});
                                        }else{
                                            window.errPopupOpen({
                                                alert:"예약 변경 불가",
                                                data:`변경된 정보가 없습니다.<br/>다시 확인 후 이용해주세요.`,
                                                closeType:true,
                                                func:()=>{}
                                            });
                                        }
                                    }}
                                />
                            </BtnBox>
                        </CarDetailControllBox>
                    </FixedSection>
                </FixedPage>
            </ContentsSection>
            <CustomPopup data={addProductPopup} basicPB={false} mSize={true}>
                <Tap
                    data={categoryData}
                    nameKey={"name"}
                    valKey={"id"}
                    nameCaption={"#"}
                    val={categoryId}
                    func={(name,val)=>{setCategoryId(val)}}
                />
                <AddProductListBox>
                    {addProductItem && addProductItem?.length > 0 ?
                        <>
                            {addProductItem && addProductItem?.map((item,i)=>(
                                <AddProductListItem
                                    key={i}
                                    addClass=""
                                    id={item.id}
                                    img={item.image_url}
                                    imgAlt={item.image_alt}
                                    category={item.category||"-"}
                                    name={item.name}
                                    price={item.price}
                                    amount={item.amount}
                                    qty={item.qty}
                                    countFunc={(qty)=>{addProductQtyFunc(item,qty)}}
                                />
                            ))}
                        </>
                    :
                        <NotItems addClass="min" text={`조건에 맞는 부가서비스가 없습니다.`}/>
                    }
                </AddProductListBox>
                <PopupCaptionTextBox>
                    <PopupCaptionTextItem
                        name="선택한 부가서비스"
                        text={`${comFormat(addProductSelItem?.length||"0")} 종`}
                    />
                    <PopupCaptionTextItem
                        name="부가서비스 총 수량"
                        text={`${comFormat(addTotalQty||"0")} 개`}
                    />
                    <PopupCaptionTextItem
                        addClass="total"
                        name="총 결제 금액"
                        text={`${comFormat(addTotalPrice||"0")} 원`}
                    />
                </PopupCaptionTextBox>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass=""
                        contents={"부가서비스 선택 완료"}
                        disabled={false}
                        func={() => {
                            addProductFunc();
                            setAddProductPopup(null);
                        }}
                    />
                </BtnBox>
            </CustomPopup>

            <CustomPopup data={reservationPopup} basicPB={true} mSize={true}>
                <TermsPopupSubTitle title={"예약 취소 규정"}/>
                <EditerBox addClass="minSize" data={ruleData?.cancel_information}/>
                <TermsPopupSubTitle title={"예약 변경 규정"}/>
                <EditerBox addClass="minSize" data={ruleData?.exchange_information}/>
            </CustomPopup>
            <Footer pcOnly={true}/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default ReservationEdit;